import { Typography } from '@chr/eds-react';
import { Translation } from '@chr/online-shared-ui-localizations';
import React from 'react';

export const RecaptchaBlurb = () => {
  return (
    <Typography variant='subtitle300'>
      <Translation resourceKey='This site is protected by reCAPTCHA and the Google'/>
      <a href="https://policies.google.com/privacy"> <Translation resourceKey='Privacy Policy'/></a> <Translation resourceKey='and'/>
      <a href="https://policies.google.com/terms"> <Translation resourceKey='Terms of Service'/></a> <Translation resourceKey='apply'/>.
    </Typography>
  );
}
